import { Col, Row } from 'antd'
import { Branches } from 'gadjet-v2-types/dist/model'

import BranchForm from '../../Forms/BranchForm'

type Props = { hqId: number; branchId: number; branch?: Branches; onRefresh: () => void }

export default function BranchTab({ hqId, branchId, branch, onRefresh }: Props): JSX.Element {
  return (
    <Row gutter={20}>
      <Col span={10}>
        <BranchForm hqId={hqId} branchId={branchId} branch={branch} onRefresh={onRefresh} />
      </Col>
    </Row>
  )
}
